// src/menu-items/other.js
import {
  IconMailHeart,
  IconCalendarWeek,
  IconCalendarEvent,
  IconUsersPlus,
  IconClock24,
  IconUsers,
  IconMailCheck,
  IconClipboardData,
  IconFileReport,
  IconUsersGroup,
  IconCalendarRepeat,
  IconCalendarMonth,
  IconChartArrows,
  IconRepeat,
  IconReportMoney,
  IconReport

} from '@tabler/icons-react';

const icons = {
  IconMailCheck,
  IconCalendarWeek,
  IconCalendarEvent,
  IconUsersPlus,
  IconClock24,
  IconUsers,
  IconClipboardData,
  IconFileReport,
  IconUsersGroup,
  IconCalendarRepeat,
  IconCalendarMonth,
  IconChartArrows,
  IconRepeat,
  IconReportMoney,
  IconReport
};

// ==============================|| OTHERS SECTION ||============================== //

// 👤 Employee-specific section
export const employeeSection = {
  id: 'employee-requests',
  title: 'General Requests', // Clear title for DEV view
  type: 'group',
  children: [
    {
      id: 'RequestEmployee',
      title: 'My Requests',
      type: 'item',
      url: '/requestemployee',
      icon: icons.IconMailCheck,
      breadcrumbs: false
    }
  ]
};

// 📊 Manager/HR Reports section
export const managerReportsSection = {
  id: 'manager-reports',
  title: 'Reports', // Clear title for DEV view
  type: 'group',
  children: [
    {
      id: 'weeklyReport',
      title: 'Weekly Report',
      type: 'item',
      url: '/reports/weekly-report',
      icon: icons.IconReport,
      breadcrumbs: false
    },
    {
      id: 'vacationPlanningReport',
      title: 'Vacation Planning',
      type: 'item',
      url: '/reports/vacation-planning',
      icon: icons.IconCalendarMonth,
      breadcrumbs: false
    },
    {
      id: 'attendanceReport',
      title: 'Attendance Report',
      type: 'item',
      url: '/reports/attendance',
      icon: icons.IconCalendarEvent,
      breadcrumbs: false
    },
    {
      id: 'employeesattendance',
      title: 'Employees Attendance',
      type: 'item',
      url: '/reports/employees-attendance',
      icon: icons.IconFileReport,
      breadcrumbs: false
    },
    {
      id: 'candidateReport',
      title: 'Recruitment Analytics',
      type: 'item',
      url: '/reports/candidates',
      icon: icons.IconUsersPlus,
      breadcrumbs: false
    },
    {
      id: 'candidateDetailsReport',
      title: 'Candidates Report',
      type: 'item',
      url: '/reports/candidate-details',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: 'probationReviewReport',
      title: 'Probation Reviews Report',
      type: 'item',
      url: '/reports/probation-reviews',
      icon: icons.IconChartArrows,
      breadcrumbs: false
    },

    {
      id: 'contractrenewalfeedbackreport',
      title: 'Contract Renewal Report',
      type: 'item',
      url: '/reports/contract-renewal-feedback',
      icon: icons.IconRepeat,
      breadcrumbs: false
    },

    {
      id: 'employeefeedbackreport',
      title: 'Feedback Report',
      type: 'item',
      url: '/reports/employee-feedback-report',
      icon: icons.IconClipboardData,
      breadcrumbs: false
    },
    {
      id: 'salaryReport',
      title: 'Salary Report',
      type: 'item',
      url: '/reports/salary-report',
      icon: icons.IconReportMoney,
      breadcrumbs: false
    },
    // {
    //   id: 'operational',
    //   title: 'Operational Hours',
    //   type: 'item',
    //   url: '/reports/operational-hours',
    //   icon: icons.IconClock24,
    //   breadcrumbs: false
    // },

    // {
    //   id: 'employeeReport',
    //   title: 'Employee Report',
    //   type: 'item',
    //   url: '/reports/employees',
    //   icon: icons.IconUsers,
    //   breadcrumbs: false
    // }
  ]
};

// 👇 Optional: Keep default export for non-DEV roles (backward compatibility)
const userRole = localStorage.getItem('userRole');

let defaultOther;
if (userRole === 'EMPLOYEE') {
  defaultOther = employeeSection;
} else if (['MANAGER', 'HR', 'DIRECTOR'].includes(userRole)) {
  defaultOther = managerReportsSection;
} else {
  // For unknown roles, return empty group
  defaultOther = { id: 'other', title: 'Other', type: 'group', children: [] };
}

export default defaultOther;

// // assets
// import { IconReportAnalytics, IconHelp, IconMailHeart, IconUsers,
//   IconUsersPlus, IconTimeDuration30, IconCalendarShare, IconCalendarEvent, IconCalendarWeek,
//   IconClock24
//  } from '@tabler/icons-react';

// // constant
// const icons = { IconReportAnalytics, IconHelp, IconMailHeart, IconUsers,
//   IconUsersPlus, IconTimeDuration30, IconCalendarShare, IconCalendarEvent,
//   IconCalendarWeek, IconClock24
//  };
// // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// const userRole = localStorage.getItem('userRole');
// const IsEmployee= userRole === 'EMPLOYEE';

// const other = {
//   id: 'other',
//   title: 'Reports',
//   type: 'group',
//   children: []
// };

// if (userRole === 'MANAGER' || userRole === 'HR'|| userRole === 'DIRECTOR') {
//   other.children.push(
//     {
//       id: 'weeklyReport',
//       title: 'Weekly Report',
//       type: 'item',
//       url: '/reports/weekly-report',
//       icon: icons.IconCalendarWeek,
//       breadcrumbs: false
//     },
//      {
//       id: 'attendanceReport',
//       title: 'Attendance Report',
//       type: 'item',
//       url: '/reports/attendance',
//       icon: icons.IconCalendarEvent,
//       breadcrumbs: false
//     },
//     {
//       id: 'candidateReport',
//       title: 'Recrutement Analytics',
//       type: 'item',
//       url: '/reports/candidates',
//       icon: icons.IconUsersPlus,
//       breadcrumbs: false
//     },
//     {
//       id: 'operational',
//       title: 'Operational Hours',
//       type: 'item',
//       url: '/reports/operational-hours',
//       icon: icons.IconClock24,
//       breadcrumbs: false
//     },
//     {
//       id: 'employeeReport',
//       title: 'Employee Report',
//       type: 'item',
//       url: '/reports/employees',
//       icon: icons.IconUsers,
//       breadcrumbs: false
//     },

//     // {
//     //   id: 'interviewReport',
//     //   title: 'Interview Report',
//     //   type: 'item',
//     //   url: '/reports/interviews',
//     //   icon: icons.IconTimeDuration30,
//     //   breadcrumbs: false
//     // },
//     // {
//     //   id: 'leaveReport',
//     //   title: 'Leave Report',
//     //   type: 'item',
//     //   url: '/reports/leaves',
//     //   icon: icons.IconCalendarShare,
//     //   breadcrumbs: false
//     // },


//   );
// }

// if (userRole === 'EMPLOYEE') {
//   other.children.push(
//     {
//       id: 'RequestEmployee',
//       title: 'My Requests ',
//       type: 'item',
//       url: '/requestemployee',
//       icon: icons.IconMailHeart,
//       breadcrumbs: false
//     },
//   );
// }

// ─── Project Manager section (EMPLOYEE with Project Manager position) ─────────
export const projectManagerSection = {
  id: 'project-manager',
  title: 'My Project',
  type: 'group',
  children: [
    {
      id: 'myTeam',
      title: 'My Team',
      type: 'item',
      url: '/my-team',
      icon: icons.IconUsersGroup,
      breadcrumbs: false,
    },
  ],
};
// export default other;
